import { useMutation } from '@tanstack/react-query';

import { fetchParticipantResearcherChatRooms } from '$app-web/api/endpoints';
import { ObjectType } from '$app-web/types';

export function useReadChatRooms(studyId?: number) {
    return useMutation({
        mutationFn: async () => {
            if (studyId != null && !Number.isNaN(studyId) && studyId > 0) {
                const [firstObjectOfResponse] = await fetchParticipantResearcherChatRooms(studyId);
                const { participantToResearcher, participantToResearchers } = firstObjectOfResponse;
                const rooms = [...participantToResearcher, ...participantToResearchers];
                const uniqueRooms = rooms.filter((room, index, self) => self.findIndex(({ id }) => id === room.id) === index);

                const roomsMap: ObjectType<{ role: 'researcher'; label: string; avatarUrl: string }> = uniqueRooms.reduce(
                    (acc, room) => ({
                        ...acc,
                        [room.id]: { label: room.humanReadableName, avatarUrl: room.avatarUrl, role: 'researcher' },
                    }),
                    {}
                );

                return roomsMap;
            } else {
                return {};
            }
        },
    });
}
